<script lang="ts" setup>
	import type { RuleObject } from 'ant-design-vue/es/form'
	import type { FormItemProps, InputProps } from 'ant-design-vue'
	import type { ClassNameValue } from 'tailwind-merge'

	const { input: inputProp, ...props } = defineProps<
		FormItemProps & {
			rules?: RuleObject
			input?: InputProps & { class?: ClassNameValue }
			wrapperClass?: ClassNameValue
			label?: string
		}
	>()

	const modelValue = defineModel<string>()
	const emit = defineEmits<{
		(arg: 'change', value: string): void
	}>()
	const validatePhoneFormat = (_: RuleObject, value: string) => {
		const defErr = (msg: string) => {
			return Promise.reject(new Error(msg))
		}

		if (!value) {
			return defErr('Please enter a valid phone number')
		} else if (!String(value).startsWith('234') || String(value).length < 13) {
			return defErr('Phone number must start with 234 and be 13 digits long')
		} else if (value[3] === '0') {
			return defErr('Invalid phone number, your number must not start with 0 after the 234 prefix.')
		}
		return Promise.resolve()
	}
	const change = (e: Event) => {
		const v = (e?.target as HTMLInputElement)?.value || ''
		emit('change', v)
	}
</script>

<template>
	<div>
		<a-form-item
			:class="cn('!my-0', wrapperClass)"
			:label="label || ''"
			:colon="false"
			:name="props.name"
			:rules="{
				...(props?.rules ?? {}),
				validator: props?.rules?.validator || validatePhoneFormat
			}"
		>
			<a-input
				v-model:value="modelValue"
				v-tel="true"
				type="tel"
				:data-testid="props.name"
				inputmode="tel"
				class="custom-input !bg-gray-50 !px-5"
				v-bind="inputProp"
				@change="change"
			/>
		</a-form-item>
	</div>
</template>
